export default __webpack_public_path__ + "static/media/google.52ade38c.svg";